export { QuickActionTile, type QuickActionTileProps } from "./QuickActionTile"
